import React, { Fragment } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';

const BuyButton = ({
    label,
    articleNumber,
    quantityFieldId,
    href,
    cssClass,
    onClick,
}) => {
    return (
        <Fragment>
            {articleNumber ? (
                <a
                    className={cssClass}
                    onClick={() => onClick({ articleNumber, quantityFieldId })}
                >
                    {label}
                </a>
            ) : (
                <a className={cssClass} href={href}>
                    {label}
                </a>
            )}
        </Fragment>
    );
};

const StyledButton = (props) => {
    const dispatch = useDispatch();
    const onClick = async ({ articleNumber, quantityFieldId }) => {
        function getIntOrUndefined(value) {
            try {
                const number = Number.parseInt(value, 10);
                return Number.isInteger(number) ? number : undefined;
            } catch {
                return undefined;
            }
        }
        try {
            const articleNr = articleNumber;
            const variantSystemId = document.getElementById("variantSystemId")?.getAttribute("data-variantId");
            const quantity = quantityFieldId ? document.getElementById("in-outcheckDates")?.getAttribute("date-quantity") : 1;
            const selectedDateFrom = document.getElementById("in-outcheckDates")?.getAttribute("data-checkin");
            const selectedDateTo = document.getElementById("in-outcheckDates")?.getAttribute("data-checkout");
            const selectedDate = document.getElementById(
                `selectedDate-${articleNumber}`
            )?.value;
            const numberOfBreakfasts = document.getElementById('numberOfBreakfasts')
                ?.value;
            const maxCapacity = document.getElementById('maxCapacity')?.value;
            const metaDataElement = document.getElementById(articleNumber);
            const additionalInfo = {
                articleNumber: articleNr,
                variantSystemId: variantSystemId,
                productTypeId: metaDataElement.getAttribute('ProductTypeId'),
                productType: metaDataElement.getAttribute('ProductType'),
                extension: metaDataElement.getAttribute('Extension'),
                selectedDate: selectedDate,
                selectedDateFrom: selectedDateFrom,
                selectedDateTo: selectedDateTo,
                numberOfBreakfasts: numberOfBreakfasts,
                maxCapacity: maxCapacity,
                numberOfDaysAccessValue: getIntOrUndefined(
                    metaDataElement.getAttribute('NumberOfDaysAccessValue')
                ),
                ageFrom: getIntOrUndefined(metaDataElement.getAttribute('AgeFrom')),
                ageTo: getIntOrUndefined(metaDataElement.getAttribute('AgeTo')),
                parkingCode: metaDataElement.getAttribute('ParkingCode'),
                parkingDate: metaDataElement.getAttribute('ParkingDate'),
                eventId: metaDataElement.getAttribute('EventId'),
                hideQrCode: metaDataElement.getAttribute('HideQrCode')
            };
            const cart = await addToCartService({
                articleNumber,
                quantity,
                additionalInfo,
            });
            dispatch(receive(cart));
            if (additionalInfo.productType === "Bookable") {
                window.location.href = cart.checkoutUrl;
            }
            return true;
        } catch (ex) {
            console.log("buy btn clicked error ", ex);
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };
    const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
    return <Button {...props} />;
};

export default StyledButton;
